import { OwcChip, OwcListItem, OwcMenu, OwcTooltip } from "@one/react";
import React, { useState } from "react";
import ReactDOM from "react-dom";

const Tags = ({ chips, rowId }) => {
  const [openChips, setOpenChips] = useState(null);
  // Light defensive guard — the OpenSearch read boundary
  // (processSearchResults in OpenSearchConfig.js) already coerces
  // list-typed fields back to arrays, so on the grid path `chips`
  // is always `T[]`. This guard only protects callers outside that
  // path (e.g. AppSync / form state) from passing undefined.
  const tags = Array.isArray(chips) ? chips : [];
  const tagsDropdown = tags.slice(1);

  if (tags.length === 0) {
    return <>-</>;
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {tags.map((tag, index) => {
            if (index < 1) {
              const tagWithEllipsis = tag.length > 20 ? tag.substring(0, 20) + "..." : tag;
              return (
                <div style={{ marginRight: 5 }}>
                  <OwcChip variant="outlined" id={tagWithEllipsis}>
                    <OwcTooltip anchor={tagWithEllipsis}>{tagWithEllipsis}</OwcTooltip>
                    {tagWithEllipsis}
                  </OwcChip>
                </div>
              );
            }
            return "";
          })}
        </div>
        {tagsDropdown?.length > 0 && (
          <>
            <div
              id={rowId}
              style={{ cursor: "pointer" }}
              onClick={(event) => {
                setOpenChips(() => event?.currentTarget);
              }}
            >
              +{tagsDropdown?.length}
            </div>
            {ReactDOM.createPortal(
              <OwcMenu
                data-testid="simple-menu"
                visible={openChips}
                onClickOutside={() => {
                  setOpenChips(() => null);
                }}
                anchor={rowId}
                style={{ height: 300 }}
              >
                {tagsDropdown?.map((tag) => (
                  <OwcListItem>{tag}</OwcListItem>
                ))}
              </OwcMenu>,
              document.body
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Tags;
